import { render } from "./AddEditCategories.vue?vue&type=template&id=06247870&scoped=true"
import script from "./AddEditCategories.vue?vue&type=script&lang=js"
export * from "./AddEditCategories.vue?vue&type=script&lang=js"

import "./AddEditCategories.vue?vue&type=style&index=0&id=06247870&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06247870"]])

export default __exports__